import { render, staticRenderFns } from "./buyerAgentFeeOrderStatList.vue?vue&type=template&id=9d82607a&scoped=true&"
import script from "./buyerAgentFeeOrderStatList.vue?vue&type=script&lang=js&"
export * from "./buyerAgentFeeOrderStatList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d82607a",
  null
  
)

export default component.exports